import { Box, Typography, useTheme } from "@mui/material";
import ArrowTickLeft from "../../../../../media/images/icons/arrow-tick-left.svg";
import MobileHeader from "../../../../layout/DriverLayout/Header";
import InfoCircle from "../../../../../media/images/icons/info-circle";
import IdentityInfo from "./IdentityInfo";
import { useAppSelector } from "../../../../../hooks/useRedux";
import IdentityDocuments from "./IdentityDocuments";
import AccommodationInfo from "./AccommodationInfo";
import BankAccountInfo from "./BankAccountInfo";
import VerifyMobileNumber from "./VerifyMobileNumber";
import IsValidPhone from "./IsValidPhone";
import { useNavigate } from "react-router-dom";

export default function EditProfile() {
  const theme = useTheme();

  const { phoneValid } = useAppSelector((state) => state.user);

  return (
    <>
      <MobileHeader title={HeadTitle()} />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          paddingX: "8px",
          paddingTop: "8px",
          paddingBottom: "150px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "bgColor.white",
            borderRadius: "8px",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              backgroundColor: theme.palette.secondary[50],
              display: "flex",
              alignItems: "start",
              gap: "8px",
              padding: "6px",
              borderRadius: "8px",
            }}
          >
            <InfoCircle color={theme.palette.secondary[600]} />
            <Box
              sx={{
                display: "flex",
                alignItems: "start",
                gap: "8px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  color: theme.palette.secondary[600],
                }}
              >
                نکته:
              </Typography>

              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: theme.palette.secondary[600],
                }}
              >
                اطلاعات هویتی شما با عکس مدارکی که ارسال می‌کنید باید یکی باشد،
                در صورت هرگونه مغایرت، احراز هویت شما انجام نمی‌شود.
              </Typography>
            </Box>
          </Box>
        </Box>
        {phoneValid ? <IsValidPhone /> : <VerifyMobileNumber />}
        <IdentityInfo />
        <IdentityDocuments />
        <AccommodationInfo />
        <BankAccountInfo />
      </Box>
    </>
  );
}

function HeadTitle() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography
        onClick={() => navigate("../profile")}
        sx={{
          cursor: "pointer",
          color: "secondary.main",
          fontWeight: 600,
          fontSize: "14px",
        }}
      >
        حساب کاربری من
      </Typography>
      <img src={ArrowTickLeft} alt="" />
      <Typography
        sx={{
          color: "secondary.main",

          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        ویرایش اطلاعات{" "}
      </Typography>
    </Box>
  );
}
